import { FC } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { VideoPlayer } from './VideoPlayer';

interface VideoWithBackButtonModalContentPropsProps {
  title?: string;
  videoId?: string;
  close: () => void;
}

export const FixedHeightDiv = styled.div`
  height: 75vh;
`;
export const VideoWithBackButtonModalContent: FC<VideoWithBackButtonModalContentPropsProps> = ({
  close,
  videoId,
  title,
}) => {
  const { formatMessage } = useIntl();
  return (
    <FixedHeightDiv className="d-flex flex-column p-3 px-md-4">
      <div className="mb-4">
        <button type="button" className="btn btn-outline-secondary" onClick={close}>
          <i className="icon icon-md me-2">arrow_back</i>
          {formatMessage({ id: 'discover.videos.back' })}
        </button>
      </div>
      {title && <h3 className="mb-4">{title}</h3>}
      <div className="w-100 pb-3 flex-grow-1">{videoId && <VideoPlayer videoId={videoId} />}</div>
    </FixedHeightDiv>
  );
};
